import React from 'react';
import LostTrackingTable from './components/LostTrackingTable';
import { connect } from 'react-redux';
import { getIsLostTrackingRunsFetching, getLostTrackingRuns, loadLostTrackingRuns } from '../duck';

class DashboardLostTracking extends React.Component {
    componentWillMount() {
        this.props.loadLostTrackingRuns();
    }

    render() {
        const { isFetching, runs } = this.props;

        return (
            <div style={{ marginTop: 20 }}>
                <LostTrackingTable data={runs} isFetching={isFetching} />
            </div>
        );
    }
}

export default connect(
    state => ({
        isFetching: getIsLostTrackingRunsFetching(state),
        runs: getLostTrackingRuns(state),
    }),
    { loadLostTrackingRuns }
)(DashboardLostTracking);
